import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  styles?: any;
  onChange?: any;
  isDisabled?: boolean;
  placeHolder?: String;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  className,
  onChange,
  isDisabled,
  placeHolder,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(
    defaultValue
  );

  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue]);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: isDisabled ? "#F8F9FA" : "white", // Ensures control has a solid background
      color: "#6B7280",
      opacity: isDisabled ? 2.9 : 1, //  Reduce opacity when disabled
      cursor: isDisabled ? "not-allowed" : "pointer", // Prevent interactions
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white", // Ensures dropdown menu has a solid background
      zIndex: 9999, // Keeps dropdown above other elements
    }),
    option: (provided: any, state: { isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : "white", // Selected option color
      color: state.isSelected ? "white" : "black", // Text color for selected and non-selected options
      "&:hover": {
        backgroundColor: "#f0f0f0", // Background color on hover
      },
    }),
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      styles={customStyles} // Apply custom styles
      options={options}
      value={selectedOption}
      onChange={onChange}
      placeholder={placeHolder || "Select"}
      isDisabled={isDisabled}
    />
  );
};

export default CommonSelect;
